<template>
    <div>
      <GmapMap
  :center="center"
  :zoom="16"
  style="width:100%;  height: 648px;"
>
  <!-- 标记当前center位置 -->
  <GmapMarker
        :position="center"
        :clickable="true"
        :draggable="false"
        @click="handleMarkerClick"
      />
</GmapMap>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// dialog 打开方式; this.refs.xxx.dialog = true

export default {
// import引入的组件需要注入到对象中才能使用
  name: 'GoogleMap',
  components: {},
  data() {
    // 这里存放数据
    return {
      dialog: false,
      formLabelWidth: '120px',
      center: { lat: -36.9151424, lng: 174.8324563 }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  mounted() {
  },
  // 监控data中的数据变化
  // 方法集合
  methods: {
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
          // lat: 45.508,
          // lng: -73.587
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

</style>

